module.exports = __webpack_public_path__ + "static/media/google.474247f5.svg";